export default {"src":"/_next/static/media/spicy.1b90b7d6.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};